module.exports = __webpack_public_path__ + "static/media/1.015f4508.svg";